import { render, staticRenderFns } from "./ContentEdit.vue?vue&type=template&id=1d558b9a"
import script from "./ContentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports